export { default } from './SimilarCustomers';
